export default [
  {
    path: '/grid_management',          //首页
    component: (resolve) => require(['@/views/grid_management/grid_management_home'], resolve),
    hidden: true,
    meta: {
      title: '首页',
      code: 'grid_management',
    },
    children: [
      {
        path: '/',        //网格统计
        component: resolve => require(['@/views/grid_management/grid_statistics'], resolve),
        meta: {
          title: '网格统计',
          code: 'grid_statistics',
        }
      },
      {
        path: 'grid_statistics',        //网格统计
        component: resolve => require(['@/views/grid_management/grid_statistics'], resolve),
        meta: {
          title: '网格统计',
          code: 'grid_statistics',
        }
      },
      {
        path: 'local_grid',        //本级网格
        name:'LocalGrid',
        component: resolve => require(['@/views/grid_management/local_grid'], resolve),
        meta: {
          title: '我的网格',
          code: 'local_grid',
        }
      },
      {
        path: 'lower_level_grid',        //下级网格
        component: resolve => require(['@/views/grid_management/lower_level_grid'], resolve),
        meta: {
          title: '下级网格',
          code: 'lower_level_grid',
        }
      },
      {
        path: 'edit_grid_info',        //编辑网格
        name: 'EditGridInfo',
        component: resolve => require(['@/views/grid_management/edit_grid_info'], resolve),
        meta: {
          title: '编辑网格',
          code: 'edit_grid_info',
        }
      },
      {
        path: 'grid_user_manage',
        component: (resolve) => require(['@/views/grid_management/grid_user_manage'], resolve),
        meta: {
          code: 'grid_user_manage',
        },
      }
    ]
  },

]


// WEBPACK FOOTER //
// ./src/router/module/grid_management.js